import { fetchData } from "../../Helpers";

export const SLIDER_STALE_TIME = 1000 * 60 * 5.5;
export const SLIDER_CACHE_TIME = Infinity;

export function getDashboardSlider() {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/slider/list",
    successCallback: resObj => {
      dataLayer.push({
        "event": "view_slider_list",
        ...resObj.data
      })
    },
    controller: controller,
  });
}

export function getDashboardSliderDescribe(uuid) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/slider/describe",
    payload: {
      slider: {
        uuid
      }
    },
    controller: controller,
  });
}

export function markSliderAsSeen(uuid) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/slider/mark-as-seen",
    successCallback: () => {},
    payload: {
      slider: {
        uuid,
      },
    },
    controller: controller,
  });
}

